import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";

import { Footer } from "../footer";
import { Header } from "../header";
import { LanguageSelectOption } from "../uncontrolled-select/types/language-select-option.interface";

@Component({
  selector: "pax-layout",
  standalone: true,
  imports: [Footer, Header],
  templateUrl: "./layout.html",
  styleUrls: ["./layout.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Layout {
  @Input() minimal?: boolean;
  @Input({ required: true }) acceptedLanguages!: LanguageSelectOption[];
  @Input() initialLanguage: LanguageSelectOption | undefined;

  @Output() changedLanguage = new EventEmitter();

  setLanguage(selectedLanguage: string) {
    this.changedLanguage.emit(selectedLanguage);
  }
}
